export default "__VITE_ASSET__CVDU7_xa__"